export enum PricingTooltipType {
  Limit = 'limit',
  Metrics = 'metrics',
  MyDevelopers = 'my-developers',
}
